import Big from 'big.js';

export const createBigNumber = (value: number | null | undefined) => {
  if (value === null || value === undefined) {
    return new Big(0);
  }
  return new Big(value);
};
